import useSWR from 'swr';
import type { SwrReturnType } from '~/models/Api';
import type { Message } from '~/models/Message';

const paths = {
  index: '/deals/:deal_id/messages'
};
type TIndex = (id: number | null) => SwrReturnType<Message[]>;
type ReturnType = {
  index: TIndex;
};

export const useMessages = (): ReturnType => {
  const index: TIndex = (dealId: number | null) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { data, mutate, error } = useSWR<Message[]>(
      dealId === null ? null : paths.index.replace(':deal_id', String(dealId))
    );
    return {
      data: data ?? null,
      mutate,
      isLoading: !data && !error,
      error
    };
  };
  return { index };
};
